export class Color {
    constructor(public color: number = 0, public alpha: number = 1) {

    }

    public get red(): number {
        return this.color >> 16;
    }

    public set red(value: number) {
        this.color = (this.color & 0xFFFF) | (value & 0xFF) << 16;
    }

    public get green(): number {
        return (this.color & 0xFF00) >> 8;
    }

    public set green(value: number) {
        this.color = (this.color & 0xFF00FF) | (value & 0xFF) << 8;
    }

    public get blue(): number {
        return this.color & 0xFF;
    }

    public set blue(value: number) {
        this.color = (this.color & 0xFFFF00) | (value & 0xFF);
    }

    public setRGB(red: number, green: number, blue: number): void {
        this.color = (red & 0xFF) << 16 | (green & 0xFF) << 8 | (blue & 0xFF);
    }

    public clone(): Color {
        return new Color(this.color, this.alpha);
    }

    private safeScaledByte(value: number, scale: number): number {
        return Math.min(0xFF, Math.max(0, value * scale));
    }

    public mix(red: number, green: number, blue: number, percent: number): void {
        var invertPercent: number = 1 - percent;
        this.setRGB(this.safeScaledByte(this.red, invertPercent) + this.safeScaledByte(red, percent),
            this.safeScaledByte(this.green, invertPercent) + this.safeScaledByte(green, percent),
            this.safeScaledByte(this.blue, invertPercent) + this.safeScaledByte(blue, percent));
    }

    public tintMatrix(percent: number): Array<number> {
        var rpercent: number = 1 - percent;
        return [
            rpercent, 0, 0, 0, this.red * percent,
            0, rpercent, 0, 0, this.green * percent,
            0, 0, rpercent, 0, this.blue * percent,
            0, 0, 0, this.alpha, 0,
        ];

    }
}


// WEBPACK FOOTER //
// ./src/framework/geom/Color.ts